import { Button, ConfigProvider, Tooltip } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRetweet } from '@fortawesome/free-solid-svg-icons';

export const ResetButton = ({ children = 'Reiniciar', compact = false, ...buttonProps }) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            colorPrimary: '#1DA261',
            algorithm: true,
          },
        },
      }}
    >
      <Tooltip title={compact ? children : null}>
        <Button
          type='primary'
          icon={<FontAwesomeIcon icon={faRetweet} />}
          {...buttonProps}
        >
          {compact ? undefined : children}
        </Button>
      </Tooltip>
    </ConfigProvider>
  )
};

// Marca el componente como un botón de Ant Design para que sea tratado como tal por los componentes que lo requieren
ResetButton.__ANT_BUTTON = true;